<template>
  <div id="app">
    <Header/>
    <Swiper/>
    <Main/>
    <Footer/>
  </div>
</template>

<script>
import Header from '../components/Header.vue'      //公共头部
import Footer from '../components/Footer.vue'      //底部
import Swiper from '../pages/home/Swiper.vue'      //轮播图
import Main from '../pages/home/Main.vue'      //轮播图


export default {
  name: 'Home',
  data () {
    return {
      msg: ''
    }
  },
  components: {
    Header,
    Footer,
    Swiper,
    Main
  }
}
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue